import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";
import { sessionStore } from "@/Globals/Stores/SessionStore";
import { CancellableWorkflowStep } from "../../BaseWorkflow/Steps/CancellableWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class UserTypeAssignmentStep extends CancellableWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.UserTypeAssignment);
    }

    public isValid(): boolean {
        const user = sessionStore.getCurrentEmployee();

        if (user?.Model?.Type === EmployeeType.Practician) {
            const userActiveSite = user.getActiveSitePrimaryAddress();

            // Create dictionnary of available organizationRules for the user
            const filteredOrgRules = new FilteredOrganizationRules(cacheStore.getFilteredOrganizationRulesParam());
            filteredOrgRules.createLicenceOrganizationRulesByCountryAndState(
                null,
                userActiveSite?.CountryLookupId,
                userActiveSite?.StateLookupId
            );

            // Check if the current org rule of the user is contained in the available organization rules
            // Show the popup if this requirement is not met
            const currentOrgRule = user.getIssuingOrgRule();
            return user.Model?.Licences?.firstOrDefault()?.ShouldUpdateLicenseOrganizationRuleIdOnNextLogin
                || !filteredOrgRules.isOrganizationInAvailableOrganizationRules(currentOrgRule);
        }

        // The popup step is not valid for clerical users
        return false;
    }

    public isCompleted(): boolean {
        const currentOrgRule = sessionStore.getCurrentEmployee().getIssuingOrgRule();
        return !!currentOrgRule;
    }

    public cancel(): void {
        sessionStore.action.logout(false);
    }
}

export { UserTypeAssignmentStep };
